/**
 * Creates a random string of 6 letters and numbers
 */
export const generateRandomString = () => Math.random().toString(36).substring(2, 8);

/**
 * Numbers only
 */
export const numbersOnly = (text: string) => text.replace(/\D/g, '');

/**
 * Convert multiple spaces to a single space and trim whitespace from the start and end of a string
 */
export const removeExtraWhitespace = (text: string) => text.replace(/\s+/g, ' ').trim();

/**
 * Remove non-breaking spaces at the beginning or end of an HTML string
 */
export const removeStartEndNonBreakingSpaces = (text: string) =>
  text.replace(/^(?:&nbsp;|\s)+|(?:&nbsp;|\s)+$/g, '');

/**
 * Remove all whitespace
 */
export const removeWhitespace = (text: string) => text.replace(/\s+/g, '');

/**
 * Slugify a string to be used in an ID or URL
 */
export const slugify = (text: string) =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

/**
 * Strip HTML tags from a string and convert common HTML entities to their corresponding characters
 *
 * Useful for getting plain text from rich text content
 */
export const stripHtml = (html: string) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  return tempDiv.textContent || tempDiv.innerText || '';
};
